export default (theme) => ({
  root: { width: '100%' },
  loadingContainer: {
    margin: 'auto',
    marginTop: '1rem',
    display: 'block',
    width: '3rem',
  },
  cardProgress: { margin: theme.spacing(2) },
  rightIcon: { marginLeft: theme.spacing(1) },
  right: { textAlign: 'right' },
  editButton: { marginTop: theme.spacing(2) },
  cardInfoLabel: { minWidth: 100 },
  button: { margin: theme.spacing(1) },
  icon: { marginLeft: theme.spacing(2) },
  cardFieldRow: { minHeight: 50 },
});
